import Box from "@mui/material/Box";
import { Stack } from "@mui/system";
import * as React from "react";
export default function Footer(props) {
  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 2 }}>
        <Stack justifyContent="center" direction="row" sx={{ pt: 4 }} spacing={5} />
      </Box>
    </React.Fragment>
  );
}
